import { isNil, omitBy } from 'lodash';

import { withTitleCasedDrugFields } from 'common/utils/titleCase';
import graphqlClient from '../graphql';
import {
  forceReturnCentralFillOrdersGql,
  listCentralFillOrdersGql,
  listCentralFillPharmaciesGql,
  listCentralFillReasonsGql,
  recallCentralFillOrdersGql,
  repostCentralFillOrderGql,
  resolveCentralFillReviewGql,
  sendOrdersToCentralFillGql,
  updateCentralFillOrderStatusGql,
  validateCentralFillEligibilityGql,
} from './gql';

export const listCentralFillPharmaciesApi = (filter) =>
  graphqlClient
    .request(listCentralFillPharmaciesGql, { filter })
    .then(({ listCentralFillPharmacies }) => listCentralFillPharmacies);

export const listCentralFillOrdersApi = ({ page = 1, limit = 25, filter, sortBy } = {}) => {
  const offset = (page - 1) * limit;
  return graphqlClient
    .request(listCentralFillOrdersGql, { limit, offset, filter: omitBy(filter, isNil), sortBy })
    .then(({ centralFillOrders }) => ({
      ...centralFillOrders,
      items: (centralFillOrders.items ?? []).map(withTitleCasedDrugFields),
    }));
};

export const resolveCentralFillReviewApi = (input) =>
  graphqlClient
    .request(resolveCentralFillReviewGql, { input })
    .then(({ resolveCentralFillReview }) => resolveCentralFillReview);

export const recallCentralFillOrdersApi = (trackingIds, note) =>
  graphqlClient
    .request(recallCentralFillOrdersGql, { input: { trackingIds, note } })
    .then(({ recallCentralFillOrders }) => recallCentralFillOrders);

export const forceReturnCentralFillOrdersApi = (trackingIds, reason) =>
  graphqlClient
    .request(forceReturnCentralFillOrdersGql, { input: { trackingIds, reason } })
    .then(({ forceReturnCentralFillOrders }) => forceReturnCentralFillOrders);

export const listCentralFillReasonsApi = () =>
  graphqlClient
    .request(listCentralFillReasonsGql)
    .then(({ listCentralFillReasons }) => listCentralFillReasons);

export const repostCentralFillOrderApi = (trackingId) =>
  graphqlClient
    .request(repostCentralFillOrderGql, { input: { trackingId } })
    .then(({ repostCentralFillOrder }) => repostCentralFillOrder);

export const updateCentralFillOrderStatusApi = (input) =>
  graphqlClient
    .request(updateCentralFillOrderStatusGql, { input })
    .then(({ updateCentralFillOrderStatus }) => updateCentralFillOrderStatus);

export const validateCentralFillEligibilityApi = (lineItemIds) =>
  graphqlClient
    .request(validateCentralFillEligibilityGql, { lineItemIds })
    .then(({ validateCentralFillEligibility }) => ({
      ...validateCentralFillEligibility,
      results: (validateCentralFillEligibility.results ?? []).map(withTitleCasedDrugFields),
    }));

export const sendOrdersToCentralFillApi = (lineItemIds) =>
  graphqlClient
    .request(sendOrdersToCentralFillGql, { lineItemIds })
    .then(({ sendOrdersToCentralFill }) => sendOrdersToCentralFill);
